<template>
<div>
<ContentOverlay ></ContentOverlay>
<div class="content_card" v-if="item">





<div class="grid">



<!--sidebar-->
<ItemSidebar :name="$store.state.brands.brand.name" 
:projectcount="projectcount"
:flowcount="flowcount"
:suppliercount="suppliercount"
></ItemSidebar>
<!--sidebar-->


<div class="col-12 md:col-10">
<div class="content_card_content">

<TabNavigation :tabs="tabs"></TabNavigation>
<router-view></router-view>

</div>
</div>

</div>




</div>
<SupplierUploadDialog></SupplierUploadDialog>
 </div> 
</template>

<script>
export default {

  name: 'Brand',

  data () {
    return {
      item:null,
      tabs: [
          {
              title: 'durum',
              icon: 'chart-line',
              route:'status'
          },
          {
              title: 'genel',
              icon: 'list',
              route:'general'
          },
          {
              title: 'ceviriler',
              icon: 'info-circle',
              route: 'translations',
          }, 
          {
              title: 'projeler',
              icon: 'calendar',
              route:'projects'
          }, 
          {
              title: 'ozel_nitelikler',
              icon: 'sliders-h',
              route:'custom_attributes'
          },
          {
              title: 'suppliers',
              icon: 'globe',
              route:'suppliers'
          },
          {
              title: 'marka_raporlari',
              icon: 'chart-bar',
              route:'brand_reports'
          },
          {
              title: 'marka_veri_girisleri',
              icon: 'chart-line',
              route:'input_submissions'
          },
          {
              title: 'tedarikci_kartlari',
              icon: 'id-card',
              route:'supplier_cards'
          }, 
          {
              title: 'kullanicilar',
              icon: 'users',
              route:'users'
          },          
          {
              title: 'marka_bildirimleri',
              icon: 'comment',
              route:'brand_notifications'
          }
      ],

    }
  },
  computed:{
    projectcount()
    {
      return this.$store.state.brands.projects
    },
    flowcount()
    {
      return this.$store.state.brands.flows
    },
    suppliercount()
    {
      return this.$store.state.brands.suppliers
    },
  },
  mounted()
  {
    
    this.getData()
    this.checkTabName(this.tabs)
  },
  methods:{
  	async getData()
    {
        this.item = await this.generalApiGet("brand/"+this.$route.params.id)
        await this.$store.dispatch('brands/setBrand',this.item) 

        if(this.$store.state.auth.userroles.includes("admin"))
        {
          {
          let the_obj = await {
            title:"is_bedelleri",
            icon: 'money-bill',
            route: 'business_return',
          }
          await this.tabs.push(the_obj)
        }
        }


        for(let tab of this.tabs)
        {
          tab.route = await "/"+this.$store.state.auth.user.uuid+"/brand/"+this.$route.params.id+"/"+tab.route
        }


        setTimeout( async()=>{
          let suppliers = await this.generalApiGetWithoutLoader("brand/all_suppliers_count/"+this.$route.params.id)
          let projects = await this.generalApiGetWithoutLoader("brand_projects_count/"+this.$route.params.id)
          let flows = await this.generalApiGetWithoutLoader("brand/flows_count/"+this.$route.params.id)
          console.log("suppliers")
          console.log(suppliers)
          await this.$store.dispatch('brands/setProjects',projects)
          await this.$store.dispatch('brands/setFlows',flows) 
          await this.$store.dispatch('brands/setSuppliers',suppliers)
        })
        
    }
  }
};
</script>

<style lang="css" scoped>
</style>